var
  buf,
  bufIdx = 0,
  hexBytes = [],
  i


// Pre-calculate toString(16) for speed
for (i = 0; i < 256; i++) {
  hexBytes[i] = (i + 0x100).toString(16).substr(1)
}

// Buffer random numbers for speed
// Reduce memory usage by decreasing this number (min 16)
// or improve speed by increasing this number (try 16384)
uuid.BUFFER_SIZE = 4096

// Binary uuids
uuid.bin = uuidBin

// Clear buffer
uuid.clearBuffer = function () {
  buf = null
  bufIdx = 0
}

// Test for uuid
uuid.test = function (uuid) {
  if (typeof uuid === 'string') {
    return /^[0-9a-f]{8}-[0-9a-f]{4}-4[0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i.test(uuid)
  }
  return false
}

// Use best available PRNG
// Also expose this so you can override it.
uuid.randomBytes = function (n) {
  var i, r = []
  for (i = 0; i < n; i++) {
    r.push(Math.floor(Math.random() * 256))
  }
  return r
}

// Buffer some random bytes for speed
function randomBytesBuffered (n) {
  if (!buf || ((bufIdx + n) > uuid.BUFFER_SIZE)) {
    bufIdx = 0
    buf = uuid.randomBytes(uuid.BUFFER_SIZE)
  }
  return buf.slice(bufIdx, bufIdx += n)
}

// uuid.bin
function uuidBin () {
  var b = randomBytesBuffered(16)
  b[6] = (b[6] & 0x0f) | 0x40
  b[8] = (b[8] & 0x3f) | 0x80
  return b
}

// String UUIDv4 (Random) without -
// the trace-id keeps 32 characters
function uuid () {
  var b = uuidBin()
  return b.reduce((p, c) => p + hexBytes[c], '')
}


/**
 * 生成 traceId 的方法
 * @returns {string} traceId
 */
function generateTraceId () {
  let traceId = uuid()
  let timestamp = Math.floor(Date.now() / 1000)
  // http://wiki.intra.xiaojukeji.com/pages/viewpage.action?pageId=91930217
  // 中间 8 位要求为 unix 时间戳，详见上面 wiki；本方案由 @ 万鼎铭 确定
  return traceId.slice(0, 8) + timestamp.toString(16) + traceId.slice(16)
}

function uuidInterceptor (config) {
  try {
    // 这里支持一下外部调用的rid覆盖，判断当外部传入非空rid时，使用外部rid，否则使用内部生成的rid
    let traceId = (config.header && config.header['didi-header-rid']) || generateTraceId()
    config.header = Object.assign({}, config.header, {
      // 添加traceId
      'didi-header-rid': traceId
    })
  } catch (e) {
  }
  return config
}

export { uuid, uuidInterceptor }
